// extracted by mini-css-extract-plugin
export default {"root":"NumberedCard_root-xSN","number":"NumberedCard_number-uCC","content":"NumberedCard_content-gj9","title":"NumberedCard_title-n4U","description":"NumberedCard_description-CE0"};